import React from "react";

const ASP_BrowserCap = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP BrowserCap</h1>
      <p>This is the ASP BrowserCap page content.</p>
    </div>
  );
};

export default ASP_BrowserCap;
